import { Injectable } from '@angular/core';
import { AutosaveRestoreDialogComponent } from 'src/app/components/dialogs/autosave-restore-dialog/autosave-restore-dialog.component';
import { ModalWindowService } from '../ui/modal-window.service';
import { IAutoSaveDoc } from './autosave.interface';

@Injectable({
  providedIn: 'root'
})
export class AutosaveRestoreService {

  constructor(
    private readonly modalWindowService: ModalWindowService,
  ) { }

  openRestoreDialog(e: Partial<IAutoSaveDoc>[]){
    this.modalWindowService.createModalWindow(AutosaveRestoreDialogComponent, e);
  }
}
